import { Modal as ReactNativeModal, Heading, Notice, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { ScrollView, Modal as NativeBaseModal, Box, FlatList } from 'native-base';
import React from 'react';

import { messageError } from '../../../NewApplication/Product/components/Equity/constants';
import { OrderEntityWithEvents } from '../OrderDetails/constants';

import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Item } from './components/Item';
import { Line } from './components/Line';
import { noticeTitle, height, orderEquityInfoGetter } from './constants';

interface EquityOrderCancelProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => Promise<void>;
  data?: OrderEntityWithEvents;
}

export const EquityOrderCancel: React.FC<EquityOrderCancelProps> = ({
  isOpen,
  onClose,
  data,
  onCancel,
}) => {
  return (
    <ReactNativeModal isOpen={isOpen} onClose={onClose} testId="equity-order-cancel">
      <NativeBaseModal.Content
        alignItems="center"
        w="full"
        maxH={{ base: height * 0.75, lg: 'full' }}
        maxW={{ base: 'full', lg: '497px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}>
        <ScrollView w="full" showsVerticalScrollIndicator={false}>
          <VStack p={Spacing['inline.xxs']} space={Spacing['stack.xxxs']}>
            <Box
              w={{ base: '55px', lg: 0 }}
              background={'neutral.lightest'}
              borderRadius={BoxRadius.sm}
              h={{ base: 1, lg: 0 }}
              mb={{ base: Spacing['inline.xxxs'], lg: 0 }}
              alignSelf={'center'}
            />
            <Header onClose={onClose} />
            <Heading testId="order-id" size="h2" color="black">
              Ordem {data?.orderHash || messageError}
            </Heading>
            <Line />
            <Notice type="alert" textObjects={noticeTitle} />
            <FlatList
              data={orderEquityInfoGetter(data)}
              keyExtractor={(item) => item.label}
              numColumns={2}
              showsVerticalScrollIndicator={false}
              renderItem={({ item, index }) => <Item item={item} index={index} />}
            />
            <Line />
            <Footer onCancel={onClose} onConfirm={onCancel} />
          </VStack>
        </ScrollView>
      </NativeBaseModal.Content>
    </ReactNativeModal>
  );
};
